interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): (number | string)[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) pages.push('left-ellipsis');
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < totalPages - 1) pages.push('right-ellipsis');
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  const baseButton =
    'flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md px-3 text-sm transition-colors';

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className={`${baseButton} ${
          page <= 1
            ? 'cursor-not-allowed bg-background-100 text-foreground-300'
            : 'bg-background-100 text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
        }`}
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {pages.map((item) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`${baseButton} ${
              item === page
                ? 'bg-primary-500 font-semibold text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="flex h-9 w-9 items-center justify-center text-foreground-500">
            …
          </span>
        ),
      )}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className={`${baseButton} ${
          page >= totalPages
            ? 'cursor-not-allowed bg-background-100 text-foreground-300'
            : 'bg-background-100 text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
        }`}
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}